<template>
  <div class="floating-alert" v-if="isVisible" :style="alertPosition">
    <v-tooltip top color="error" max-width="250">
      <template v-slot:activator="{ on, attrs }">
        <div 
          class="alert-button alert-warning pulsing" 
          v-bind="attrs"
          v-on="on"
          @click="handleClick"
        >
          <!-- Icono de advertencia principal -->
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" class="warning-icon">
            <path d="M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"/>
          </svg>
        </div>
      </template>
      <span>{{ tooltipMessage }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
    name: 'BurbleAlert',
    props: {
        message: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'Instagram',
        },
        type_error: {
            type: String,
        },
        cardNumber: {
            type: Number,
            required: true,
        },
        position: {
            type: String,
            default: 'left', // 'left' o 'right'
        },
    },

    data() {
        return {
            isVisible: false,
            isPulsing: true,
        }
    },

    computed: {
        tooltipMessage() {
            if (this.type_error && this.type_error === 'instagram_not_found') {
                return `Verifique si su ${this.type} es correcto.`;
            }
            return `Olvidaste poner tu ${this.type}.`;
        },

        alertPosition() {
            return {
                position: 'absolute',
                top: '8px',
                right: '8px',
                zIndex: 100,
            };
        }
    },

    methods: {
        handleClick() {
            this.isPulsing = false;
            this.$emit('alert-clicked', this.type, this.cardNumber);
        },

        getCardElement() {
            // Si es redes sociales (cardNumber = 0), buscar el elemento socials
            if (this.cardNumber === 0) {
                return document.querySelector('#socials');
            }

            // Para tarjetas normales
            let cardElement = document.querySelector(`#card${this.cardNumber}`);

            if (!cardElement) {
                cardElement = document.querySelector(`[id="card${this.cardNumber}"]`);
            }

            return cardElement;
        },

        checkCardVisibility() {
            const cardElement = this.getCardElement();
            if (cardElement) {
                const rect = cardElement.getBoundingClientRect();
                const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
                this.isVisible = isVisible;
            } else {
                // Si no se encuentra el elemento, mostrar la alerta de todos modos
                this.isVisible = true;
            }
        }
    },

    mounted() {

        this.isVisible = true;

        // Delay escalonado para aparición
        setTimeout(() => {
            this.checkCardVisibility();
            
            // Listener para scroll para mostrar/ocultar según visibilidad de la tarjeta
            window.addEventListener('scroll', this.checkCardVisibility);
            window.addEventListener('resize', this.checkCardVisibility);
        }, 300);
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.checkCardVisibility);
        window.removeEventListener('resize', this.checkCardVisibility);
    }
}
</script>

<style scoped>
.floating-alert {
    cursor: pointer;
    transition: all 0.3s ease;
}

.alert-button {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 16px;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    position: relative;
    border: 2px solid rgba(255, 255, 255, 0.4);
}

.alert-button:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    border-color: rgba(255, 255, 255, 0.7);
}

.alert-warning {
    background: linear-gradient(135deg, #ef4444 0%, #f54c4c 50%, #ff5757 100%);
}

.platform-icon {
    position: absolute;
    bottom: 1px;
    right: 1px;
    width: 14px;
    height: 14px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.4);
}

.warning-icon {
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

.pulsing {
    animation: urgentPulse 0.5s infinite;
}

@keyframes urgentPulse {
    0% {
        transform: scale(1.5);
        opacity: 1;
        box-shadow: 0 3px 8px rgba(239, 68, 68, 0.4);
    }
    50% {
        transform: scale(1.05);
        opacity: 0.85;
        box-shadow: 0 5px 15px rgba(239, 68, 68, 0.6);
    }
    100% {
        transform: scale(1);
        opacity: 1;
        box-shadow: 0 3px 8px rgba(239, 68, 68, 0.4);
    }
}
</style>